export default __webpack_public_path__ + "static/media/dark_recyclebin_icon.667e6aa6.svg";